import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  confirmDelete,
  ErrorMsg,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../Util/common";
import { KendoGrid } from "../../Kendo/kendo_grid";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";
import { KendoLoader } from "../../Kendo/kendo_loader";
import { toast } from "react-toastify";

export const Awards = () => {
  const fileInputRef = useRef(null);
  const [AwardsList, setAwardsList] = useState({
    ImageId: 0,
    Images: [],
    OldImagePath: "",
  });
  const [error, setError] = useState({});
  const modalRef = useRef(null);
  const [editVisible, seteditVisible] = useState(false);
  const [refreshGrid, setrefreshGrid] = useState(0);
  const [Loading, setLoading] = useState(false);

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const clearForm = () => {
    $("#hide").click();
    setLoading(false);
    setAwardsList({
      ImageId: 0,
      Images: [],
      OldImagePath: "",
    });
    setError({});
    seteditVisible(false);
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = null;
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter((file) => file.type.startsWith("image/"));
    const hasAvifFile = files.some(
      (file) => file.type === "image/avif" || file.name.endsWith(".avif")
    );

    if (hasAvifFile) {
      toast.error("Uploaded images contain unsupported formats.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (validFiles.length != files.length) {
      setError({ ...error, ValidFile: true });
      e.target.value = "";
    } else {
      setError({ ...error, ValidFile: false });

      // const maxSizeInKB = 500;
      // const maxSizeInBytes = maxSizeInKB * 1024;

      // if (validFiles.size > maxSizeInBytes) {
      //   setError({ ...error, InValidFileSize: true });
      //   setAwardsList((prev) => ({
      //     ...prev,
      //     Image: "",
      //   }));
      // } else {
      setError({ ...error, InValidFileSize: false });
      setAwardsList((prevState) => ({
        ...prevState,
        Images: validFiles,
      }));

      onValidation("Image", e.target.value);
      // }
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    var err = ValidateForm(e);
    if (err) {
      setError(err);
    } else {
      try {
        setLoading(true);
        const formData = new FormData();
        if (AwardsList.Images && AwardsList.Images.length > 0) {
          AwardsList.Images.forEach((file) => {
            formData.append("Images", file);
          });
        }
        formData.append("AwardsID", AwardsList.ImageId);
        formData.append("OldImagePath", AwardsList.OldImagePath || "");
        formData.append("SavedBy", sessionUser());
        await corepost("HighlightsAwards/UploadAwardsImages", formData);
        clearForm();
        $("#Awards-cancel").click();
        setrefreshGrid(refreshGrid + 1);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleEditClick = async (e) => {
    let temp = AwardsList;

    AwardsList.ImageId = e.awardsID;
    AwardsList.Images = [];
    AwardsList.OldImagePath = e.imagePath;
    setAwardsList(temp);

    seteditVisible(true);
    const modal = new bootstrap.Modal(document.getElementById("AwardsModal"));
    modal.show();
  };

  const handleDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `HighlightsAwards/DeleteAwards?id=${
          e.awardsID
        }&DeletedBy=${sessionUser()}`,
        true,
        false,
        true
      ).then(() => {
        setrefreshGrid(refreshGrid + 1);
      });
    };
    confirmDelete(onDelete);
  };

  const onRowReorderChange = async (List) => {
    let AwardsId = $(List.newRow).find("td").eq(0).text();
    let oldSortId = $(List.newRow).find("td").eq(1).text();
    let newSortId = $(List.oldRow).find("td").eq(1).text();
    await corefetch(
      `HighlightsAwards/SortAwards?TypeId=${AwardsId}&NewOrder=${newSortId}&OldOrder=${oldSortId}`
    );
    setrefreshGrid(refreshGrid + 1);
  };

  // useEffect(() => {
  //   const searchBox = document.querySelector('.k-toolbar .k-searchbox');
  //   if (searchBox) {
  //     searchBox.style.display = 'none'; // Hide the search box
  //   }
  // }, []);
  return (
    <>
      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  <Button
                    name={"Add"}
                    dataBsToggle={"modal"}
                    dataBsTarget={"#AwardsModal"}
                    dataBsDismiss={"modal"}
                  />
                </div>
              </div>
            </div>

            <div>
              <i>
                <span style={{ backgroundColor: "yellow", fontWeight: "bold" }}>
                  Note:
                </span>{" "}
                This module supports drag-and-drop functionality. You can easily
                rearrange or move data as needed.
              </i>
              <KendoGrid
                name={"AwardsGrid"}
                url={CorebaseURL + "HighlightsAwards/GetAwards"}
                schema={{
                  fileName: { type: "string" },
                }}
                columns={[
                  { field: "awardsID", hidden: true },
                  {
                    template: function (e) {
                      if (e.imagePath) {
                        return `<img src="${ImageURL}${e.imagePath}" width="40px" height="40px" />`;
                      }
                      return "";
                    },

                    title: "Image",
                  },
                  {
                    field: "imagePath",
                    title: "File Name",
                    template: function (e) {
                      if (e.imagePath) {
                        return `<p>${e.imagePath.split("/").pop()}</p>`;
                      }
                      return "";
                    },
                  },
                ]}
                showOptions={true}
                showEdit={true}
                showDelete={true}
                disableExportExcel={true}
                height={"60vh"}
                refreshWhen={refreshGrid}
                onEditClick={(e) => handleEditClick(e)}
                onDeleteClick={(e) => {
                  handleDeleteClick(e);
                }}
                enableRowReorderable={true}
                onRowReorder={onRowReorderChange}
              />
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Add Awards Modal --> */}
      <div
        className="modal custom-modal fade"
        id="AwardsModal"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {editVisible ? "Edit Awards" : "Add Awards"}
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="AwardsForm" onSubmit={onSubmit}>
                <input
                  type="hidden"
                  name="ImageId"
                  value={AwardsList.ImageId || 0}
                />
                <div className="row">
                  <div className="col-md-12">
                    <label className="form-label">
                      Upload Awards Images{" "}
                      <span className="text-danger">*</span>
                      <InfoIcon
                        content="Please ensure each image is uploaded within a maximum size of 500KB;
                      Please upload the images in JPEG, JPG or PNG format."
                      />
                    </label>
                    <br></br>
                    <span style={{ color: "crimson" }}>
                      Note:You can upload multiple files simultaneously in a
                      single action.
                    </span>

                    <input
                      className="form-control"
                      type="file"
                      name="file"
                      accept="image/*"
                      multiple
                      onChange={handleFileChange}
                    />
                    {error.Image && (
                      <ErrorMsg text="Aleast one Image is required" />
                    )}
                    {error.ValidFile && (
                      <ErrorMsg text="please upload Image file only" />
                    )}
                    {error.InValidFileSize && (
                      <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file." />
                    )}
                  </div>
                  <div className="row mt-1 mb-3">
                    {AwardsList.OldImagePath && AwardsList.ImageId > 0 && (
                      <div
                        style={{
                          width: "100%",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <a
                          href={`${ImageURL}${AwardsList.OldImagePath}`}
                          target="_blank"
                          style={{
                            textDecoration: "underline",
                            fontSize: "13px",
                          }}
                        >
                          {AwardsList.OldImagePath.split("/").pop()}
                        </a>
                      </div>
                    )}
                    <input
                      type="hidden"
                      name="Image"
                      id="image-name"
                      data-required={AwardsList.ImageId > 0 ? "false" : "true"}
                      value={AwardsList.Images || ""}
                    />
                    <input
                      type="hidden"
                      name="OldimagePath"
                      value={AwardsList.OldImagePath}
                    />
                  </div>
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="Awards-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    />

                    <Button name={editVisible ? "Update" : "Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Add Awards Modal --> */}
    </>
  );
};
